export const EstadoVisualizacion = Object.freeze({
    PENDIENTE: "PENDIENTE",
    VISUALIZADO: "VISUALIZADO",
    NO_APLICA:"NO_APLICA"
});
